import { Tooltip, Typography } from "antd";
import { FC } from "react";

const { Text } = Typography;

const AdvertOptions: FC<{ options: string; type: number, isBoldFontColored?:boolean }> = ({ options, type,isBoldFontColored }) => {
  let parsedOptions: Record<string, any> = {};

  try {
    parsedOptions = JSON.parse(options);
  } catch {
    return <Text>JSON valid değil</Text>;
  }

  const priorityKeys = type === 1 ? ["m²", "Kat Sayısı", "Oda Sayısı"] : ["Yıl", "KM", "Renk"];
  const selectedValues: JSX.Element[] = [];
  priorityKeys.forEach((key) => {
    if (parsedOptions[key] && selectedValues.length < 3) {
      let value = parsedOptions[key];
      const normalizedValue = value?.trim()?.toLowerCase();

    
      if (["evet", "hayır", "hayir"].includes(normalizedValue)) {
        value = key;
      } else {
       
        if (key.toLowerCase().includes("km") && !String(value).toLowerCase().includes("km")) {
          value += " Km";
        }

       
        if (key.includes("m²") && !String(value).includes("m²")) {
          value += " m²";
        }
      }

      selectedValues.push(
        <Tooltip title={key} key={key}>
          <span className={`!text-[10px] ${isBoldFontColored?"!font-bold":""}`} >{value}</span>
        </Tooltip>
      );
    }
  });

  // Eğer öncelikli key'lerden 3 tanesi seçilmezse, diğer seçenekleri ekle
  if (selectedValues.length < 3) {
    Object.entries(parsedOptions).forEach(([key, value]) => {
      if (!priorityKeys.includes(key) && selectedValues.length < 3) {
        const normalizedValue = value?.trim()?.toLowerCase();
        const displayValue =
          ["evet", "hayır", "hayir"].includes(normalizedValue)
            ? key
            : ["m² (Net)", "m² (Brüt)"].includes(key)
            ? value + ` ${key}`
            : key === "KM" && !String(value).toLowerCase().includes("km")
            ? value + " KM"
            : value;
      
        selectedValues.push(
          <Tooltip title={key} key={key}>
            <span className={`!text-[10px]   ${isBoldFontColored?"!font-bold":""}`}>{displayValue}</span>
          </Tooltip>
        );
      }
      
    });
  }

  if (selectedValues.length === 0) {
    return <Text className={`!text-[5px]   ${isBoldFontColored?"!font-bold":""}`} >{""}</Text>;
  }

  return <Text className={`!text-[5px] ${isBoldFontColored?"!font-bold":""}`}>{selectedValues.map((item, index) => (index > 0 ? [" | ", item] : item))}</Text>;
};

export default AdvertOptions;
